import { ThemeEvents } from '@theme/events';

/**
 * Mention Klarna (blocks/cf-klarna.liquid) : échéancier calculé sur le prix
 * de la variante sélectionnée.
 */
class CfKlarna extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-ref="dialog"]');
    this.querySelector('[data-ref="open"]').addEventListener('click', () => this.open());
    this.querySelector('[data-ref="close"]').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    // Suit le changement de variante pour garder le bon montant
    const section = this.closest('.shopify-section') || document;
    section.addEventListener(ThemeEvents.variantUpdated, (event) => {
      const price = event.detail?.resource?.price;
      if (price != null) this.dataset.price = price;
    });
  }

  open() {
    const total = parseInt(this.dataset.price, 10) / 100;
    const count = parseInt(this.dataset.installments, 10) || 3;
    const share = Math.round((total / count) * 100) / 100;
    const money = (value) => value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    const date = (months) => {
      const d = new Date();
      d.setMonth(d.getMonth() + months);
      return months === 0 ? "Aujourd'hui" : d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    };

    this.querySelector('[data-ref="total"]').textContent = `${money(total)} en ${count} versements`;
    this.querySelector('[data-ref="schedule"]').innerHTML = Array.from(
      { length: count },
      (_, i) => `<li><strong>${money(share)}</strong><span>${date(i)}</span></li>`,
    ).join('');
    this.dialog.showModal();
  }
}

if (!customElements.get('cf-klarna')) {
  customElements.define('cf-klarna', CfKlarna);
}
